import React from 'react'
import { Input } from '@/components/ui/input'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import LocalFilterPanel from '@/components/common/LocalFilterPanel'

export default function TracePivotTableSettings({
  objectTypeFilter,
  onObjectTypeChange,
  activityFilter,
  onActivityFilterChange,
  componentTitle,
  onTitleChange,
  availableObjectTypes,
  availableActivities,
  localFilters,
  updateLocalFilter,
  activeFile,
}) {
  return (
    <div className="space-y-4">
      {/* Title */}
      <div className="space-y-1.5">
        <label htmlFor="trace-pivot-title" className="text-sm font-medium leading-none">
          Tile Title
        </label>
        <Input
          id="trace-pivot-title"
          value={componentTitle}
          onChange={(e) => onTitleChange(e.target.value)}
          placeholder="Pivot Table"
        />
      </div>

      {/* Object type filter */}
      <div className="space-y-1.5">
        <label className="text-sm font-medium leading-none">Object Type</label>
        <Select
          value={objectTypeFilter ?? '__all__'}
          onValueChange={(val) => onObjectTypeChange(val === '__all__' ? null : val)}
        >
          <SelectTrigger>
            <SelectValue placeholder="All object types" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="__all__">All object types</SelectItem>
            {(availableObjectTypes ?? []).map((ot) => (
              <SelectItem key={ot} value={ot}>
                {ot}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      {/* Activity filter */}
      <div className="space-y-1.5">
        <label className="text-sm font-medium leading-none">Activity</label>
        <Select
          value={activityFilter ?? '__all__'}
          onValueChange={(val) => onActivityFilterChange(val === '__all__' ? null : val)}
        >
          <SelectTrigger>
            <SelectValue placeholder="All activities" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="__all__">All activities</SelectItem>
            {(availableActivities ?? []).map((act) => (
              <SelectItem key={act} value={act}>
                {act}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      {/* Local filters */}
      {localFilters && updateLocalFilter && (
        <div className="pt-2">
          <LocalFilterPanel
            localFilters={localFilters}
            updateLocalFilter={updateLocalFilter}
            activeFile={activeFile}
          />
        </div>
      )}
    </div>
  )
}
